import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment.prod';
import { DeliveryDto } from '@models/users/delivery.dto';
import { ShippingCreationDto } from '@models/users/shipping-creation.dto';
import { ShippingDeliveryDto } from '@models/users/shipping-delivery.dto';
import { ShippingDto } from '@models/users/shipping.dto';

@Injectable({
  providedIn: 'root',
})
export class ShippingService {
  constructor(private http: HttpClient) {}

  getShippings() {
    return this.http.get<ShippingDto[]>(environment.host + '/shippings/list');
  }

  getShippingUserList() {
    return this.http.get<ShippingDeliveryDto[]>(
      environment.host + '/shippings/user-list',
    );
  }

  createShipping(subs: ShippingCreationDto) {
    return this.http.post(environment.host + '/shippings/create', subs);
  }

  removeShipping(subs: ShippingDto[]) {
    return this.http.post(environment.host + '/shippings/remove', subs);
  }

  setAsDelivered(subs: DeliveryDto) {
    return this.http.post(environment.host + '/shippings/delivered', subs);
  }
}
